import * as yup from 'yup';

export const sell_order_schema = {
  amount: '',
  fundName: '',
};

export const sell_order_validation_schema = yup.object().shape({
  amount: yup
    .string()
    .required('amount_required')
    .matches(/^(?:\d+|\d+\.\d*)$/, 'amount_digit_validation'),
});
